import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

// Accept unknown so callers that hold a TAS FieldValue (or similarly
// broadly-typed value) can pipe it in directly; non-string inputs hit the
// `!valueToFormat` / try/catch guards below and return undefined.
type Positional = [unknown];

type Named = {
  month?: 'numeric' | '2-digit' | 'short' | 'long' | undefined;
  day?: 'numeric' | '2-digit' | undefined;
  year?: 'numeric' | '2-digit' | undefined;
  hour?: 'numeric' | '2-digit' | undefined;
  minute?: 'numeric' | '2-digit' | undefined;
  hour12?: boolean | undefined;
  timeZone?: string | undefined;
  timeZoneName?: 'short' | 'long' | undefined;
  weekday?: 'narrow' | 'short' | 'long' | undefined;
  locale?: string | undefined;
  format?: string | undefined;
};

export interface SafeFormatDateSignature {
  Args: {
    Positional: Positional;
    Named: Named;
  };
  Return: string | undefined;
}

/**
 * Returns a formatted date if a parsable value exists, otherwise return null
 * without raising an app-blocking error.
 *
 * {{safeFormatDate @createdAt}}
 *
 */
export default class SafeFormatDate extends Helper<SafeFormatDateSignature> {
  @service declare intl: IntlService;

  compute([valueToFormat]: Positional, options: Named = {}) {
    if (!valueToFormat || typeof valueToFormat !== 'string') {
      return;
    }

    try {
      return this.intl.formatDate(valueToFormat, options);
    } catch (e) {
      console.warn(e);
    }
    return;
  }
}
